
import backgorundImage from "../assets/Background.png"

export const colors = {
  gray: '#2e2d2c',
  degrade: 'linear-gradient(70deg, #000000, #eee)',
  backcolor: '#272726',
  backbeige: '#BFA38A',
  BACK: '#BFA38A',
  box: 'white',
  textcolor: '#002169',
  DARK_BLUE: '#8990a2',
  MARINO: '#002339',
  LGREEN: '#002339',
  YELLOW: '#F7B42D',
  BLACK: '#000',
  BLUE: '#011F26',
  MINICARD: '#D1C2BE',
  GRAY: '#333',
  WHITE: '#FFFFFF',
  GREEN: '#0A8E30',
  MODE: 'cruz',
  CORAL: 'rgb(226 80 89)',
  BLUE_HI: '#055686',
  FUCSIA: 'rgb(193, 26, 70)',
  DORADO: 'rgb(189,155,91)',
  BACKG_Color: '#3B4450',
  GRAYL: '#d3d3d3',
  TITLES: '#fff',
  ORANGE: '#FF7D01',
  NAV_Menu: '#595048',
  MARRON_OSCURO: '#8c7570',
  RED: '#E4414B',
  LIGHT_BLUE: '#7ec3df',
  DARKGREEN: '#666F88 ',
  backGroundImage: backgorundImage,
  backGroundColor: 'false',
  //   //'#7d9707'
};
